import { CasStackRow, CasBaseDialog } from 'src/compass/shared/components';
import { ICasBaseDialog } from 'src/compass/shared/components/CasDialog/CasBaseDialog';
import CurrentPeriodDisplay from './CurrentPeriodDisplay';

type CasDialogProps = ICasBaseDialog & {
  showPeriodStartDate?: boolean;
  children: React.ReactNode;
};

export default function CasPeriodDialog({
  id,
  title,
  children,
  showPeriodStartDate,
  ...other
}: CasDialogProps) {
  return (
    <CasBaseDialog
      {...other}
      title={
        <CasStackRow gapSize="none">
          {title}
          <CurrentPeriodDisplay />
        </CasStackRow>
      }
      showCloseIcon
    >
      {children}
    </CasBaseDialog>
  );
}
